import React, { ReactNode } from 'react';
import { AuthorizedSection } from './AuthorizedSection';

interface Props {
  children?: ReactNode;
}

export const GreenAuthorizedSection = ({ children }: Props) => {
  return <AuthorizedSection hasGreenSideViewAccess>{children}</AuthorizedSection>;
};
